import { combineReducers } from 'redux';
import * as types from './types';

const getUserNotificationsReducer = (
  state = {
    isLoading: false,
    error: null,
    entity: []
  },
  action
) => {
  switch (action.type) {
    case types.FETCH_USER_NOTIFICATIONS:
      return { ...state, ...action.payload };
    case types.FETCH_USER_NOTIFICATIONS_ERROR:
      return { ...state, ...action.payload };
    case types.FETCH_USER_NOTIFICATIONS_SUCCESS:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const dismissUserNotificationReducer = (
  state = {
    isLoading: false,
    error: null,
    isDismissed: false
  },
  action
) => {
  switch (action.type) {
    case types.DISMISS_USER_NOTIFICATION:
      return { ...state, ...action.payload };
    case types.DISMISS_USER_NOTIFICATION_SUCCESS:
      return { ...state, ...action.payload };
    case types.DISMISS_USER_NOTIFICATION_ERROR:
      return { ...state, ...action.payload };
    default:
      return state;
  }
};

const reducer = combineReducers({
  getUserNotifications: getUserNotificationsReducer,
  dismissUserNotification: dismissUserNotificationReducer
});

export default reducer;
